import { PatientStackParamList } from '@/navigations/PatientStack';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useEffect, useRef } from 'react';
import { AppState, AppStateStatus, Platform } from 'react-native';

export const usePrivacy = (isAuthenticated: boolean) => {
  const currentAppState = useRef(AppState.currentState);
  const navigation =
    useNavigation<StackNavigationProp<PatientStackParamList>>();

  const showPrivacyPage = () => {
    navigation.navigate('Privacy');
  };

  const handleAppStateChange = (nextState: AppStateStatus) => {
    if (!isAuthenticated || Platform.OS === 'web') return;
    const notActive = nextState === 'inactive' || nextState === 'background';
    if (notActive) showPrivacyPage();
    else navigation.canGoBack() && navigation.goBack();
    currentAppState.current = nextState;
  };
  useEffect(() => {
    const subscription = AppState.addEventListener(
      'change',
      handleAppStateChange,
    );
    return () => {
      subscription.remove();
    };
  }, []);
};
